import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-black">
      <Navigation />
      
      <main className="pt-[90px]">
        {/* Hero Section */}
        <section className="bg-gradient-to-b from-[#0A0A0A] to-black py-32">
          <div className="max-w-[1400px] mx-auto px-8">
            <div className="max-w-4xl">
              <div className="inline-flex items-center px-4 py-2 border border-copper/30 rounded-full mb-8">
                <span className="text-xs uppercase tracking-wider text-copper">About MACGOC</span>
              </div>
              <h1 className="text-6xl lg:text-7xl font-bold text-white mb-8 leading-tight">
                Strategic Consulting Platform for{' '}
                <span className="bg-copper-gradient bg-clip-text text-transparent">
                  Enterprise Excellence
                </span>
              </h1>
              <p className="text-xl text-gray-400 leading-relaxed">
                MACGOC was envisioned as a strategic consulting platform to deliver enterprise-grade advisory services across technology, healthcare, logistics, fuel retail, and finance.
              </p>
            </div>
          </div>
        </section>

        {/* Mission Section */}
        <section className="bg-charcoal-dark py-24">
          <div className="max-w-[1400px] mx-auto px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
              <div>
                <h2 className="text-4xl font-bold text-white mb-6">Our Mission</h2>
                <p className="text-lg text-gray-400 leading-relaxed mb-6">
                  MACGOC operates through established U.S. entities to provide top-tier professional services that transform operations and drive sustainable growth. We combine strategic advisory with execution excellence to deliver measurable results.
                </p>
                <p className="text-lg text-gray-400 leading-relaxed">
                  Our platform is built on decades of combined leadership experience across military operations, healthcare administration, business development, and international consulting.
                </p>
              </div>
              <div className="relative h-[400px] rounded-2xl overflow-hidden">
                <img
                  src="https://public.readdy.ai/ai/img_res/134b6f062eff86ef9c33cd443340d7c9.jpg"
                  alt="MACGOC Mission"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
              </div>
            </div>
          </div>
        </section>

        {/* Operating Entities */}
        <section className="bg-black py-24">
          <div className="max-w-[1400px] mx-auto px-8">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-white mb-4">Operating Through U.S. Entities</h2>
              <p className="text-lg text-gray-400 max-w-3xl mx-auto">
                MACGOC delivers services through established U.S.-registered corporations with proven track records in their respective industries.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="bg-charcoal border border-charcoal-light rounded-2xl p-10">
                <div className="w-16 h-16 bg-copper-gradient rounded-full flex items-center justify-center mb-6">
                  <i className="ri-building-line text-3xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-white mb-4">MACAR Enterprises Corp.</h3>
                <p className="text-base text-gray-400 leading-relaxed">
                  North American Division of MACGOC, providing comprehensive business consulting, technology services, logistics advisory, and fuel retail consulting across the United States.
                </p>
              </div>

              <div className="bg-charcoal border border-charcoal-light rounded-2xl p-10">
                <div className="w-16 h-16 bg-copper-gradient rounded-full flex items-center justify-center mb-6">
                  <i className="ri-hospital-line text-3xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-white mb-4">North American Healthcare Group Corp.</h3>
                <p className="text-base text-gray-400 leading-relaxed">
                  Healthcare Division of MACAR Enterprises, specializing in hospital operations optimization, accreditation readiness, healthcare supply chain redesign, and digital health transformation.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Values Section */}
        <section className="bg-charcoal-dark py-24">
          <div className="max-w-[1400px] mx-auto px-8">
            <h2 className="text-4xl font-bold text-white text-center mb-16">Our Core Values</h2>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {[
                {
                  icon: 'ri-shield-check-line',
                  title: 'Integrity',
                  description: 'We operate with unwavering ethical standards and transparency in every engagement.',
                },
                {
                  icon: 'ri-lightbulb-line',
                  title: 'Excellence',
                  description: 'We deliver superior results through expertise, innovation, and continuous improvement.',
                },
                {
                  icon: 'ri-team-line',
                  title: 'Partnership',
                  description: 'We build long-term relationships based on trust, collaboration, and mutual success.',
                },
              ].map((value, index) => (
                <div key={index} className="text-center">
                  <div className="w-20 h-20 bg-copper/10 rounded-full flex items-center justify-center mx-auto mb-6">
                    <i className={`${value.icon} text-5xl text-copper`}></i>
                  </div>
                  <h3 className="text-2xl font-bold text-white mb-4">{value.title}</h3>
                  <p className="text-base text-gray-400 leading-relaxed">{value.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="bg-black py-24">
          <div className="max-w-[1400px] mx-auto px-8 text-center">
            <h2 className="text-5xl font-bold text-white mb-6">
              Ready to Work With Us?
            </h2>
            <p className="text-xl text-gray-400 mb-10 max-w-2xl mx-auto">
              Discover how MACGOC can transform your operations and drive sustainable growth.
            </p>
            <a
              href="/contact"
              className="inline-flex items-center gap-2 bg-copper hover:bg-copper-light text-white px-12 py-4 rounded-full text-lg font-semibold transition-all duration-300 whitespace-nowrap"
            >
              Get in Touch
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default AboutPage;